import { trackEvent } from 'services/event-tracking';

export const TEXT_PROMO_URL = 'https://www.livechat.com/move-to-text';

export function trackTextPromoClick(surface: string, destination = TEXT_PROMO_URL): void {
  trackEvent('Text promo clicked', null, { surface, destination });
}
